import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Header } from "./header";
import { selectAuth } from "../../store/auth/selector";
import { Stack, useMediaQuery } from "@mui/material";
import { layoutPrivateStyle } from "../../styles/common/sidebar";
import { SideMenuAdmin } from "../RevampedSidebar";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

export function LayoutPrivateRoute({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  const location = useLocation();
  const auth = useSelector(selectAuth);
  const isSmall = useMediaQuery("(min-width: 600px)");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  if (!auth.user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <Box component="main" className="flex flex-col content-center items-center">
      <Header />
      <Box className="flex w-screen">
        <SideMenuAdmin adminMenu={!isSmall} />
        <Box className="min-w-[calc(100vw-240px)] h-[calc(100vh-64px)] w-full overflow-auto">
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default LayoutPrivateRoute;
